import { defineSlotRecipe } from "@chakra-ui/react-v3";
import { statusAnatomy } from "@chakra-ui/react-v3/anatomy";

/**
 * Chakra's Status, sized in Tiger Cloud's scale. The indicator is a fixed dot
 * rather than a share of the text size, because the places that use it put the
 * dot on an icon, where it has to stay small and round.
 */
export const statusRecipe = defineSlotRecipe({
  className: "tiger-status",
  slots: statusAnatomy.keys(),

  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      gap: "2",
      borderRadius: "full",
      borderWidth: "1px",
      borderColor: "var(--status-border-color, {colors.bg.container})",
    },
    indicator: {
      flexShrink: 0,
      borderRadius: "full",
      bg: "colorPalette.solid",
      forcedColorAdjust: "none",
    },
  },

  variants: {
    size: {
      sm: {
        indicator: { boxSize: "1.5" },
      },
      md: {
        indicator: { boxSize: "2" },
      },
      lg: {
        indicator: { boxSize: "2.5" },
      },
    },
  },

  defaultVariants: {
    size: "md",
  },
});
